/**
 * Hook for managing message ratings.
 * Writes to messages.rating and messages.rating_example in Supabase.
 */

import { useState, useCallback } from "react"
import { supabase } from "@/lib/data"
import { UseRatingsResult } from "../types"

export function useRatings(): UseRatingsResult {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submitRating = useCallback(async (
    messageId: string,
    rating: "0" | "1",
    example?: string
  ) => {
    setLoading(true)
    setError(null)
    try {
      const { error: err } = await supabase
        .from("messages")
        .update({
          rating,
          rating_example: example || null,
        })
        .eq("id", messageId)

      if (err) throw err
    } catch (err) {
      console.error("[useRatings] submitRating failed:", err)
      setError(err instanceof Error ? err.message : "Failed to submit rating")
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return { submitRating, loading, error }
}
